import { createAsyncThunk } from '@reduxjs/toolkit';
import { demandPollApi } from 'container/demandPollApi';
import { ProjectModel } from 'api/dto/Project.dto';
import { STORE_NAME } from 'reduxStore/project/initialState';
import { selectCurrentProjectId } from 'reduxStore/project/projectSelector';
import { serializeError } from 'shared/utils/redux';

export const createDemandPoll = createAsyncThunk(
  `${STORE_NAME}/createDemandPoll`,
  ({ model }: { model: ProjectModel | any }, { getState }) => {
    const projectId = selectCurrentProjectId(getState());
    return demandPollApi.create(projectId, model);
  },
  { serializeError },
);
